import type { DataBucket, BarDataPoint } from './types'

const eValue = Math.exp(1)

export function antilog(n: number, base = eValue) {
    if (base === eValue) return Math.exp(n)
    return Math.pow(base, n)
}

/**
 * Returns data in buckets, and ensures the upperBound values
 * returned by elastic search never overlaps with lowerBound values
 * (gaps in the data will be returned as bars with a `count` of zero).
 */
//
export function convertToHistogramBars(values: DataBucket[]): BarDataPoint[] {
    return values.map(
        (
            bucket: { lowerBound: number; upperBound: number; count: number },
            i
        ) => {
            const upperBoundNum = getUpperBound(bucket, values[i + 1])
            return {
                lowerBound: bucket.lowerBound,
                upperBound: upperBoundNum,
                count: bucket.count,
            }
        }
    )
}

function getUpperBound(bucket: DataBucket, nextBucket?: DataBucket) {
    let upperBound = bucket.upperBound
    if (
        nextBucket !== undefined &&
        // check for overlapping buckets
        (bucket.upperBound > nextBucket.lowerBound ||
            // check for weird case where elastic search is returning an upperBound
            // lower than the lowerBound
            bucket.upperBound < bucket.lowerBound)
    ) {
        upperBound = nextBucket.lowerBound
    }

    // if the upper bound is still less than the lowerBound after all of that,
    // just set it to the lowerBound of the current bucket
    if (upperBound < bucket.lowerBound) {
        upperBound = bucket.lowerBound
    }
    return upperBound
}

export function formatNumberToSignificantDigits(number: number) {
    if (number >= 1_000_000_000) {
        return `${parseFloat((number / 1_000_000_000).toFixed(1))}B`
    }
    if (number >= 1_000_000) {
        return `${parseFloat((number / 1_000_000).toFixed(1))}M`
    }
    if (number >= 1_000) {
        return `${parseFloat((number / 1_000).toFixed(1))}K`
    }
    return number
}
